'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z' });

var PregnantWoman = function PregnantWoman(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PregnantWoman = (0, _pure2.default)(PregnantWoman);
PregnantWoman.muiName = 'SvgIcon';

exports.default = PregnantWoman;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PregnantWoman.js
// module id = 2740
// module chunks = 0